import React, { createContext, useContext, useState } from 'react';

const ModalContext = createContext();
export const ModalProvider = ({ children }) => {

  const [showCreateStoreModal, setShowCreateStoreModal] = useState(false);
  const [showDeleteStoreModal, setShowDeleteStoreModal] = useState(false);
  const [showEditStoreModal, setShowEditStoreModal] = useState(false);

  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const [showEditUserModal, setShowEditUserModal] = useState(false);

  const [showImportModal, setShowImportModal] = useState(false);
  const [showImportSheetModal, setShowImportSheetModal] = useState(false);
  const [showExportSheetModal, setExportSheetModal] = useState(false);

  const [showImportListModal, setImportListModal] = useState(false);
  const [showViewImportTemplateModal, setShowViewImportTemplateModal] = useState(false);
  const [showEditImportTemplateModal, setShowEditImportTemplateModal] = useState(false);
  const [showDeleteImportTemplateModal, setShowDeleteImportTemplateModal] = useState(false);

  const [showCreateProductModal, setShowCreateProductModal] = useState(false);
  const [showDeleteProductModal, setShowDeleteProductModal] = useState(false);
  const [showEditProductModal, setShowEditProductModal] = useState(false);

  const [showDeleteExpiredProductModal, setShowDeleteExpiredProductModal] = useState(false);
  const [showEditExpiredProductModal, setShowEditExpiredProductModal] = useState(false);

  const [showFilterModal, setFilterModal] = useState(false);
  const [showTransferModal, setTransferModal] = useState(false);
  const [showExportPdfModal, setExportPdfModal] = useState(false);

  const [showCreateClientModal, setShowCreateClientModal] = useState(false);
  const [showDeleteClientModal, setShowDeleteClientModal] = useState(false);
  const [showEditClientModal, setShowEditClientModal] = useState(false);

  const [showCreateAdminUserModal, setShowCreateAdminUserModal] = useState(false);
  const [showDeleteAdminUserModal, setShowDeleteAdminUserModal] = useState(false);
  const [showEditAdminUserModal, setShowEditAdminUserModal] = useState(false);

  const openCreateStoreModal = () => setShowCreateStoreModal(true);
  const closeCreateStoreModal = () => setShowCreateStoreModal(false);

  const openDeleteStoreModal = () => setShowDeleteStoreModal(true);
  const closeDeleteStoreModal = () => setShowDeleteStoreModal(false);

  const openEditStoreModal = () => setShowEditStoreModal(true);
  const closeEditStoreModal = () => setShowEditStoreModal(false);

  const openCreateUserModal = () => setShowCreateUserModal(true);
  const closeCreateUserModal = () => setShowCreateUserModal(false);

  const openDeleteUserModal = () => setShowDeleteUserModal(true);
  const closeDeleteUserModal = () => setShowDeleteUserModal(false);

  const openEditUserModal = () => setShowEditUserModal(true);
  const closeEditUserModal = () => setShowEditUserModal(false);

  const openImportModal = () => setShowImportModal(true);
  const closeImportModal = () => setShowImportModal(false);

  const openImportSheetModal = () => setShowImportSheetModal(true);
  const closeImportSheetModal = () => setShowImportSheetModal(false);

  const openExportSheetModal = () => setExportSheetModal(true);
  const closeExportSheetModal = () => setExportSheetModal(false);

  const openImportListModal = () => setImportListModal(true);
  const closeImportListModal = () => setImportListModal(false);

  const openViewImportTemplateModal = () => setShowViewImportTemplateModal(true);
  const closeViewImportTemplateModal = () => setShowViewImportTemplateModal(false);

  const openEditImportTemplateModal = () => setShowEditImportTemplateModal(true);
  const closeEditImportTemplateModal = () => setShowEditImportTemplateModal(false);

  const openDeleteImportTemplateModal = () => setShowDeleteImportTemplateModal(true);
  const closeDeleteImportTemplateModal = () => setShowDeleteImportTemplateModal(false);

  const openCreateProductModal = () => setShowCreateProductModal(true);
  const closeCreateProductModal = () => setShowCreateProductModal(false);

  const openDeleteProductModal = () => setShowDeleteProductModal(true);
  const closeDeleteProductModal = () => setShowDeleteProductModal(false);

  const openEditProductModal = () => setShowEditProductModal(true);
  const closeEditProductModal = () => setShowEditProductModal(false);

  const openEditExpiredProductModal = () => setShowEditExpiredProductModal(true);
  const closeEditExpiredProductModal = () => setShowEditExpiredProductModal(false);

  const openDeleteExpiredProductModal = () => setShowDeleteExpiredProductModal(true);
  const closeDeleteExpiredProductModal = () => setShowDeleteExpiredProductModal(false);

  const openFilterModal = () => setFilterModal(true);
  const closeFilterModal = () => setFilterModal(false);

  const openTransferModal = () => setTransferModal(true);
  const closeTransferModal = () => setTransferModal(false);

  const openExportPdfModal = () => setExportPdfModal(true);
  const closeExportPdfModal = () => setExportPdfModal(false);

  const openCreateClientModal = () => setShowCreateClientModal(true);
  const closeCreateClientModal = () => setShowCreateClientModal(false);

  const openDeleteClientModal = () => setShowDeleteClientModal(true);
  const closeDeleteClientModal = () => setShowDeleteClientModal(false);

  const openEditClientModal = () => setShowEditClientModal(true);
  const closeEditClientModal = () => setShowEditClientModal(false);

  const openCreateAdminUserModal = () => setShowCreateAdminUserModal(true);
  const closeCreateAdminUserModal = () => setShowCreateAdminUserModal(false);

  const openDeleteAdminUserModal = () => setShowDeleteAdminUserModal(true);
  const closeDeleteAdminUserModal = () => setShowDeleteAdminUserModal(false);

  const openEditAdminUserModal = () => setShowEditAdminUserModal(true);
  const closeEditAdminUserModal = () => setShowEditAdminUserModal(false);


  return (
    <ModalContext.Provider value={{
      showCreateStoreModal, 
      openCreateStoreModal, 
      closeCreateStoreModal,

      showDeleteStoreModal,
      openDeleteStoreModal,
      closeDeleteStoreModal,

      showEditStoreModal,
      openEditStoreModal,
      closeEditStoreModal,

      
      showCreateUserModal,
      openCreateUserModal,
      closeCreateUserModal,

      showDeleteUserModal,
      openDeleteUserModal,
      closeDeleteUserModal,

      showEditUserModal,
      openEditUserModal,
      closeEditUserModal,

      showImportModal,
      openImportModal,
      closeImportModal,

      showImportSheetModal,
      openImportSheetModal,
      closeImportSheetModal,

      showExportSheetModal,
      openExportSheetModal,
      closeExportSheetModal,

      showImportListModal,
      openImportListModal,
      closeImportListModal,

      showViewImportTemplateModal,
      openViewImportTemplateModal,
      closeViewImportTemplateModal,

      showEditImportTemplateModal,
      openEditImportTemplateModal,
      closeEditImportTemplateModal,

      showDeleteImportTemplateModal,
      openDeleteImportTemplateModal,
      closeDeleteImportTemplateModal,

      showCreateProductModal, 
      openCreateProductModal, 
      closeCreateProductModal,

      showDeleteProductModal,
      openDeleteProductModal,
      closeDeleteProductModal,

      showEditProductModal,
      openEditProductModal,
      closeEditProductModal,

      showEditExpiredProductModal,
      openEditExpiredProductModal,
      closeEditExpiredProductModal,

      showDeleteExpiredProductModal,
      openDeleteExpiredProductModal,
      closeDeleteExpiredProductModal,

      showFilterModal,
      openFilterModal,
      closeFilterModal,

      showTransferModal,
      openTransferModal,
      closeTransferModal,

      showExportPdfModal,
      openExportPdfModal,
      closeExportPdfModal,

      showCreateClientModal, 
      openCreateClientModal, 
      closeCreateClientModal,

      showDeleteClientModal,
      openDeleteClientModal,
      closeDeleteClientModal,

      showEditClientModal,
      openEditClientModal,
      closeEditClientModal,

      showCreateAdminUserModal,
      openCreateAdminUserModal,
      closeCreateAdminUserModal,

      showDeleteAdminUserModal,
      openDeleteAdminUserModal,
      closeDeleteAdminUserModal,

      showEditAdminUserModal,
      openEditAdminUserModal,
      closeEditAdminUserModal,

    }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  return useContext( ModalContext );
};
